var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    'container-border-wrapper',
    _vm.form.editing === _vm.field.uuid ? 'editing' : ''
  ]},[_c('div',{staticClass:"left"}),_c('div',{staticClass:"top"}),_c('div',{staticClass:"right"}),_c('div',{staticClass:"bottom"})])}
var staticRenderFns = []

export { render, staticRenderFns }